import React from 'react';
import { pawnPhotoUrl } from '../../utils/pawnPhotoUrl';

export default function PawnPhotoThumbs({ urls = [], size = 72 }) {
  const list = (urls || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="d-flex flex-wrap gap-2">
      {list.map((url) => {
        const src = pawnPhotoUrl(url);
        return (
          <a
            key={url}
            href={src}
            target="_blank"
            rel="noreferrer"
            className="pawn-photo-thumb"
            title="Open photo"
          >
            <img
              src={src}
              alt="Pledge"
              width={size}
              height={size}
              style={{ objectFit: 'cover', borderRadius: 8, border: '1px solid #e2e8f0' }}
              loading="lazy"
            />
          </a>
        );
      })}
    </div>
  );
}
